module.exports = __webpack_public_path__ + "img/1462583092.3f4a3e24.jpg";